module.exports = __webpack_public_path__ + "img/restauranthinten.0bf8d6fb.jpg";